
<div #modal class="right-modal-body">
  @if (selectedWorkforceData && (workForceInfoView =='user_info')) {
    <div>
      <div class="workforceHeaderInfo row no-gutters">
        <div class="col-md-8 col-sm-8 col-8 mt-3 row pl-3 pt-2">
          <div class="title col-md-9 col-sm-9 col-9">
            {{selectedWorkforceData.fullName}}
            <div class="title-sub-4 mt-1">
              {{ 'Not in Compliance' | translate }}
            </div>
            <div class="subscribers-content mt-4">
              <span class="material-icons">mail</span> {{selectedWorkforceData.userName}}
            </div>
            <div class="subscribers-content mt-1">
              <span class="material-icons">remember_me</span> {{selectedWorkforceData.securityProfile}}
            </div>
          </div>
          <div class="title-sub-1 col-md-2 col-sm-2 col-2 pt-1 pl-2">
            {{selectedWorkforceData.securityProfile}}
          </div> &nbsp;&nbsp;
          <div class=" link-cursor" (click)="editWorkForceProfile()"><span class="material-icons build text-white">edit</span></div>
          @if (showEditWorkforcePopup && userUpdateModel) {
            <div class="edit-workforce" (mouseleave)="(showEditWorkforcePopup = false)">
              <div class="row mt-4 ml-1 mr-3">
                <div class="col-md-9 text-yellow">
                  {{ 'EDIT PROFILE' | translate }}
                </div>
                <div class="col-md-3 pl-3">
                  <span class="material-symbols-outlined" (click)="deleteUser()">delete</span>
                  <span class="material-symbols-outlined pl-1">
                    archive
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 ml-3 mr-3 mb-3 mt-2">
                  <div class="group-select2">
                    <span class="text">
                      <span class="position-absolute mt-12-px">
                        <span class="material-symbols-outlined">account_circle</span>
                      </span>
                      <input type="text" class="border-0 w-90 ml-4 mr-3 pl-2" [(ngModel)]="userUpdateModel.fullName"></span>
                      <select class="custom-dropdown" [(ngModel)]="userUpdateModel.securityProfileId">
                        <option value="0">{{ 'User' | translate }}</option>
                        <option value="1">{{ 'Admin' | translate }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="row col-md-11 ml-3 mr-3 mb-3">
                    <span class="workforce-input-text">
                      <span class="position-absolute">
                        <span class="material-symbols-outlined">email</span>
                      </span>
                      <input type="text" class="border-0 ml-4 mr-3" [(ngModel)]="userUpdateModel.userName">
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="row col-md-11 ml-3 mr-3 mb-3">
                    <span class="workforce-input-text ">
                      <span class="position-absolute">
                        <span class="material-symbols-outlined">assignment_ind</span>
                      </span>
                      <input type="text" class="border-0 ml-4 mr-3" [placeholder]="'User Role' | translate">
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="row col-md-11 ml-3 mr-3 mb-3">
                    <button type="button" class="btn btn-primary1 createButton" (click)="updateUserProfile()">{{ 'UPDATE' | translate }}</button>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="col-md-4 col-sm-4 col-4 mt-4 no-gutters">
            <div class="float-right">
              <span class="text-white title-sub-2 float-right">{{ 'Added Date' | translate }}</span>
            </div>
            <br/>
            <div class="float-right">
              <div class="title-sub-3"> {{userWorkforceStats?.added_date}}</div>
            </div>
            <div class="mt-2 text-white float-right pt-1 vertical-align-middle">
              {{userWorkforceStats?.department_type}} &nbsp;
              <span class="material-icons build text-warning">expand_more</span>
            </div>
            <div class="report-btn float-right mt-1">
              {{ 'Generate Report' | translate }}
            </div>
          </div>
        </div>
        <div class="card-data card-top-margin col-height">
          <div class="card-heading fl-row">
            <div class="heading-text">
              <h5 class="header-font">{{ 'Average Exposure' | translate }}</h5>
            </div>
          </div>
          <div class="endpoints-data card-box-dd col-child-height fl-row no-gutters">
            <div class="col-md-6 col-sm-6 col-6">
              <div class="exposure-block">
                <div class="text-center">
                  <span>{{ 'Noise Exposure' | translate }}</span><br/>
                </div>
                <div class="vertical-align-middle p-2 pt-4 items-align-middle">
                  <span class="text-yellow">{{userWorkforceStats?.noise_exposure ? userWorkforceStats?.noise_exposure : 0}}dB &nbsp;</span>
                  <span class="material-icons show-info" (mouseover)="showinfo=true" (mouseout)="showinfo=false">info</span>
                </div>
                @if (showinfo) {
                  <div class="info-box">
                    <span class="text-yellow">{{ 'Information' | translate }}</span>
                    <br/>
                    <span class="text-small text-white">
                      {{ 'OSHA requires employers to implement a hearing conservation program when noise exposure is at or above 85 decibels averaged over 8 working hours, or an 8-hour time-weighted average (TWA).' | translate }}
                    </span>
                    <br/>
                    <span class="app-color-3 link-cursor">{{ 'Know More' | translate }}</span>
                  </div>
                }
                <div>
                </div>
                <div class="vertical-align-middle pt-2 items-align-middle">
                  <span class="text-grey text-small">{{ 'Medium' | translate }} &nbsp;</span>
                </div>
              </div>
              <div class="vertical-align-middle pt-2 items-align-middle">
                <div id="gaugeChart1" style="width: 100%; height: 200px"></div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-6">
              <div class="exposure-block">
                <div class="text-center">
                  <span>{{ 'Dust Exposure' | translate }}</span>
                </div>
                <div class="vertical-align-middle pt-2 items-align-middle">
                  <span class="text-grey text-small">{{ 'Respirable PM' | translate }} &nbsp;</span>
                </div>
                <div class="vertical-align-middle items-align-middle">
                  <span class="text-green">{{userWorkforceStats?.respirable_pm ? userWorkforceStats?.respirable_pm : 0}}µg/m3 &nbsp;</span>
                  <span class="material-icons">info</span>
                </div>
                <div class="vertical-align-middle pt-2 items-align-middle">
                  <span class="text-grey text-small">{{userWorkforceStats?.dust_exposure ? userWorkforceStats?.dust_exposure : ''}} &nbsp;</span>
                </div>
              </div>
              <div class="vertical-align-middle pt-2 items-align-middle">
                <div id="gaugeChart2" style="width: 100%; height: 200px"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-data card-top-margin col-height">
          <div class="card-heading fl-row">
            <div class="heading-text">
              <h5 class="header-font pt-1">{{ 'Active Devices' | translate }}  <span class="text-small app-color-dark pl-3 pt-1 link-cursor" (click)="showAddDevicePopUp = true">{{ '+Add' | translate }}</span>
              <span class="text-small app-color-dark pl-3 float-right pt-1 link-cursor" (click)="workForceInfoView = 'device_history'">{{ 'Device History' | translate }}</span>
              <!-- <app-add-device-pop-up [showPopUp] = "showAddDevicePopUp" (hidePopUpEmitter)="initializeChart()"></app-add-device-pop-up> -->
            </h5>
          </div>
        </div>
        @if (userWorkforceStats?.active_devices) {
          <div class="endpoints-data card-box-dd col-child-height row no-gutters">
            @for (device of userWorkforceStats?.active_devices; track trackByIndex($index)) {
              <div class="col-md-6 col-sm-6 col-6">
                <span class="material-icons">hearing</span>
                <div class="mt-2"><strong>{{device?.name ? device?.name : ''}}</strong></div>
                <div class="row mt-2 no-gutters">
                  <div class="col-md-5 col-sm-5 col-5 text-small"><strong> {{device?.start_date}}</strong> <br/> {{device?.start_time}} </div>
                  <div class="col-md-1 col-sm-1 col-1"><strong>&nbsp; - &nbsp;</strong></div>
                  <div class="col-md-5 col-sm-5 col-5 text-small">&nbsp;<strong>{{device?.end_date}}</strong> <br/>&nbsp; {{device?.end_time}} </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12 col-sm-12 col-12">
                    <span class="material-icons build">toggle_on</span>&nbsp;&nbsp;
                    <span class="material-icons build">edit</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="card-data card-top-margin col-height">
        <div class="card-heading fl-row">
          <div class="heading-text">
            <h5 class="header-font pt-1">{{ 'Endpoints Managed' | translate }}  <span class="text-small app-color-dark pl-3 pt-1">{{ '+Add' | translate }}</span></h5>
          </div>
        </div>
        @if (userWorkforceStats?.managed_endpoints) {
          <div class="endpoints-data card-box-dd col-child-height row no-gutters">
            @for (device of userWorkforceStats?.managed_endpoints; track trackByIndex($index)) {
              <div class="col-md-4 col-sm-4 col-4">
                <span class="material-icons">{{device.icon}}</span>
                <div class="mt-2 vertical-align-middle">
                  <strong>{{device.name}}</strong>
                  <span class="bg-dark float-right ml-2" style="height: 20px;border-radius: 5px;">
                    <span class="material-icons text-white vertical-align-middle mr-1" style="height: 18px;width: 15px; font-size: 1.0000em;">play_arrow</span>
                  </span>
                </div>
                <span class="material-symbols-outlined bar-cd mt-1">delete</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if ((workForceInfoView == 'device_history') && selectedWorkforceData) {
    <app-device-history (hideHistoryView)="workForceInfoView = 'user_info'" [filterValue]="selectedWorkforceData.userName"></app-device-history>
  }
</div>
